import { DefaultError, useMutation, useQueryClient } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IAuthUserListItem, ICreateAuthUserBody } from './types';

export const usePostAuthCreate = () => {
  const queryClient = useQueryClient();
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('usePostAuthCreate');

  return useMutation<IAuthUserListItem, DefaultError, ICreateAuthUserBody>({
    async mutationFn(body) {
      loading(
        i18next.t('service-message.create.loading', {
          what: i18next.t('user.what'),
        })
      );

      const response = await apiClient({
        method: 'POST',
        url: 'Auth/Create',
        body,
      });

      return responseHandler(response, {
        groupName: 'usePostAuthCreate',
      });
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['admin-auth-users-list'] });
      success(
        i18next.t('service-message.create.success', {
          what: data.userName ?? i18next.t('user.what'),
        })
      );
    },
    onError: dismiss,
  });
};
